import React, { useEffect, useRef } from 'react'
import { withSnackbar } from 'notistack'
import Autocomplete from '@material-ui/lab/Autocomplete'
import {
  withStyles,
  TextField,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Grid,
  InputAdornment,
  Box,
  List,
  ListItem,
  ListItemText
} from '@material-ui/core'

import LambdaFetch from '../functions/FetchFromLambda'
import LoadingButton from './LoadingButton'
import { AntTabsVert, AntTab } from './common/Tabs'
import LoadingCircle from './common/LoadingCircle'
import { createMuiTheme } from '@material-ui/core/styles'
import { v4 as uuidv4 } from 'uuid'
import LazyLoadingAutocomplete from '../functions/LazyLoadingAutocomplete'
import ServerSideAutoCompletev2 from '../functions/ServerSideAutoCompletev2'
import SeverSideMultiAutoComplete from '../functions/SeverSideMultiAutoComplete'
import DateInput from './DateInput'
import { SignalWifiStatusbar4BarRounded } from '@mui/icons-material'
import OpenSearchDropdown from './OpenSearchDropdown'
import { resolveEnabledModules, isModuleEnabled } from '../config/permissions-registry'
const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    alignItems: 'left'
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`
  },
  tabsRoot: {
    borderBottom: '1px solid #e8e8e8'
  },
  tabsIndicator: {
    backgroundColor: '#E86613'
  },
  selected: {},
  tabRoot: {
    textTransform: 'initial',
    minWidth: 72,
    '&:hover': {
      color: '#E86613',
      opacity: 1
    },
    '&$selected': {
      color: '#E86613'
    },
    '&:focus': {
      color: '#E86613',
      outline: 'none'
    },
    '&:active': {
      outline: 'none'
    }
  },
  primaryVLButton: {
    color: 'white',
    backgroundColor: '#E86613',
    marginLeft: 15,
    width: 'min-content',
    '&:hover': {
      backgroundColor: 'rgba(232, 102, 19, .9)'
    }
  }
})

function AthenaReports (props) {
  const [state, setState] = React.useState({
    currentReport: null,
    currentReportDropdowns: {},
    reports: [],
    isLoading: true,
    paramOpen: false,
    paramDropDowns: false,
    isSubmitting: false,
    tableCol: null,
    tableData: null,
    tabs: [],
    tabValue: 0,
    openPrintDialog: false,
    reportData: []
  })

  // Track if component is mounted to prevent state updates after unmount
  const isMountedRef = useRef(true)

  async function fetchReports () {
    try {
      const resp = await LambdaFetch(
        'reports-athena',
        'post',
        props.fetchInitialData.credentials.user.accessToken,
        JSON.stringify({
          action: 'get-all-reports-catalog'
        }),
        '',
        props.fetchInitialData.credentials
      )

      if (resp.success) {

        const allow = props?.fetchInitialData?.credentials?.allow || (() => false)
        const allowCategory = (subkey) => allow('reportCategory', subkey)
        const allowedCatelog = resp.data.catalog.filter(report => allowCategory(report.category))

        const tabs = allowedCatelog.reduce((acc,cur) => {
          if (acc.indexOf(cur.category) === -1) {
            acc.push(cur.category)
          }  
          return acc
        },[]).sort()
        
        if (isMountedRef.current) {
          setState({
            ...state,
            reports: allowedCatelog,
            isLoading: false,
            tabs: tabs
          })
        }
      } else {
        if (isMountedRef.current) {
          setState({ ...state, isLoading: false }, () => {
            createSnack('There was a error grabbing the reports', 'error', 3500)
          })
        }
      }
    } catch (e) {
      console.log(e)
    }
  }


  const [reportParams, setReportParams] = React.useState({})
  useEffect(() => {
    isMountedRef.current = true
    
    fetchReports()
    
    // Cleanup function to set mounted flag to false when component unmounts
    return () => {
      isMountedRef.current = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const createSnack = (message, type, duration) => {
    props.enqueueSnackbar(message, {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
      },
      variant: type,
      autoHideDuration: duration
    })
  }

  const handleClose = () => {
    setState({
      ...state,
      currentReport: null,
      currentReportDropdowns: {},
      paramOpen: false,
      paramDropDowns: false
    })
    setReportParams({})
  }
  const handleRedirect = href => {
    window.open(href, '_blank')
  }
  const getOptions = async (queries, report) => {
    try {
      if (isMountedRef.current) {
        setState({
          ...state,
          currentReport: report
        })
      }
      const resp = await LambdaFetch(
        'reports',
        'post',
        props.fetchInitialData.credentials.user.accessToken,
        JSON.stringify({
          action: 'basic-query',
          ...{
            queries: queries
          }
        }),
        '',
        props.fetchInitialData.credentials
      )
      if (resp.success) {
        const data = resp.data

        if (isMountedRef.current) {
          setState({
            ...state,
            dropdownData: data.myResults,
            currentReport: report,
            paramOpen: true,
            paramDropDowns: true
          })
          for (let dropdown in data.myResults) {
            onTagsChange(null, data.myResults[dropdown][0], dropdown)
          }
        }
      }
    } catch (e) {
      console.log(e)
    }
  }
  const handleCurrentReport = report => {
    let myQueries = report.parameters.reduce((acc, field) => {
      if (field.fieldType === 'dynamicList') {
        return [...acc, { id: field.name, query: field.query }]
      } else return acc
    }, [])
    if (myQueries.length > 0) {
      getOptions(myQueries, report)
    } else {
      setState({
        ...state,
        currentReport: report,
        paramOpen: true,
        paramDropDowns: true
      })
    }

    let reportParams = report.parameters.reduce((acc, field) => {
      acc[field.name] = null
      return acc
    }, {})
    setReportParams(reportParams)
  }

  const runBuiltSqlReport = async event => {
    event.preventDefault()
    try {
      const parameters = typeof state.currentReport.parameters === 'string'
        ? JSON.parse(state.currentReport.parameters)
        : state.currentReport.parameters
      const namedParams = parameters.reduce((acc, cur) => {
        if (cur.fieldType === 'autocomplete-all') {
          acc[cur.name] = event.target[cur.name].value
        } else if (cur.fieldType === 'smart-autocomplete') {
          acc[cur.name] = reportParams[cur.name] ? reportParams[cur.name] : ''
        } else if (cur.fieldType === 'date') {
          acc[cur.name] = reportParams[cur.name] ? reportParams[cur.name] : ''
        } else if (cur.fieldType === 'dynamicList') {
          acc[cur.name] = reportParams[cur.name].value
        } else if (cur.fieldType && cur.fieldType.toLowerCase() === 'opensearch') {
          acc[cur.name] = reportParams[cur.name] ? reportParams[cur.name] : ''
        } else {
          acc[cur.name] = event.target[cur.name].value
        }
        return acc
      }, {})
      const reportingParams = parameters.reduce((acc, cur) => {
        if (cur.fieldType === 'autocomplete-all') {
          acc[cur.displayName] = event.target[cur.name].value
        } else if (cur.fieldType === 'smart-autocomplete') {
          acc[cur.name] = reportParams[cur.name] ? reportParams[cur.name] : ''
        } else if (cur.fieldType === 'date') {
          acc[cur.displayName] = reportParams[cur.name] ? reportParams[cur.name] : ''
        } else if (cur.fieldType === 'dynamicList') {
          acc[cur.displayName] = reportParams[cur.name].value
        } else if (cur.fieldType && cur.fieldType.toLowerCase() === 'opensearch') {
          acc[cur.displayName] = reportParams[cur.name] ? reportParams[cur.name] : ''
        } else {
          acc[cur.displayName] = event.target[cur.name].value
        }
        return acc
      }, {})

      const fetchData = {
        action: 'run-built-query',
        id: state.currentReport.id,
        namedParams: namedParams,
        eventName: event.target.jobName.value,
        reportingParams: JSON.stringify(reportingParams)
      }

      const resp = await LambdaFetch(
        'reports-athena',
        'post',
        props.fetchInitialData.credentials.user.accessToken,
        JSON.stringify({
          ...fetchData
        }),
        '',
        props.fetchInitialData.credentials,
        true
      )

      if (resp.success) {
        if (isMountedRef.current) {
          setState({
            ...state,
            isSubmitting: false,
            paramOpen: false,
            paramDropDowns: false
          })
          if (resp.data.execution.QueryExecution.Status.State === 'FAILED') {
            props.fetchInitialData.createSnack(
              resp.data.execution.QueryExecution.Status.StateChangeReason,
              'error',
              3000
            )
          } else {
            props.fetchInitialData.createSnack(
              'Successfully ran report',
              'success',
              3000
            )
          }
        }
      } else {
        if (isMountedRef.current) {
          setState({ ...state, isSubmitting: false, paramOpen: false })
          props.fetchInitialData.createSnack(resp.data.body, 'error', 5000)
        }
      }
    } catch (e) {
      console.log(e)
    }
  }
  const runReport = async event => {
    event.preventDefault()
    try {
      const { user } = props.fetchInitialData.credentials

      setState({ ...state, isSubmitting: true })
      let parameters = state.currentReport.parameters
      let paramsConditions = []

      const reportParameterObj = parameters.reduce((acc, cur) => {
        if (
          cur.fieldType === 'autocomplete-all' ||
          cur.fieldType === 'autocomplete-serverside' ||
          cur.fieldType === 'smart-autocomplete'
        ) {
          acc[cur.name] = reportParams[cur.name] ? reportParams[cur.name] : ''
        } else if (cur.fieldType === 'date') {
          acc[cur.name] = reportParams[cur.name] ? reportParams[cur.name] : ''
        } else if (cur.fieldType === 'dynamicList') {
          acc[cur.name] = reportParams[cur.name].value
        } else if (cur.fieldType && cur.fieldType.toLowerCase() === 'opensearch') {
          acc[cur.name] = reportParams[cur.name] ? reportParams[cur.name] : ''
        } else {
          acc[cur.name] = event.target[cur.name].value
        }
        return acc
      }, {})

      const reportingParams = parameters.reduce((acc, cur) => {
        if (cur.fieldType === 'autocomplete-all') {
          acc[cur.displayName] = event.target[cur.name].value
        } else if (cur.fieldType === 'smart-autocomplete') {
          acc[cur.name] = reportParams[cur.name] ? reportParams[cur.name] : ''
        } else if (cur.fieldType === 'date') {
          acc[cur.displayName] = reportParams[cur.name] ? reportParams[cur.name] : ''
        } else if (cur.fieldType === 'dynamicList') {
          acc[cur.displayName] = reportParams[cur.name].value
        } else if (cur.fieldType && cur.fieldType.toLowerCase() === 'opensearch') {
          acc[cur.displayName] = reportParams[cur.name] ? reportParams[cur.name] : ''
        } else {
          acc[cur.displayName] = event.target[cur.name].value
        }
        return acc
      }, {})

      let params = parameters.map(p => {
        return reportParameterObj[p.name].toString()
      })

      let fetchData = {
        report_name: state.currentReport.named_query,
        document_name: state.currentReport.report_name,
        reportParameterObj,
        eventName: event.target.jobName.value,
        roles: user.roles,
        reportingParams: JSON.stringify(reportingParams)
      }

      const fetchBody = {
                isReport: true,
                reportName: state.currentReport.named_query,
                document_name: state.currentReport.report_name,
                eventName: event.target.jobName.value,
                reportingParams: JSON.stringify(reportingParams),
                variables: { ...reportParameterObj }
              }
            const resp = await LambdaFetch(
              'athena/execute',
              'post',
              props.fetchInitialData.credentials.user.accessToken,
              JSON.stringify(fetchBody),
              '',
              props.fetchInitialData.credentials
            )
      
            if (resp.success) {
              if (isMountedRef.current) {
                setState({
                  ...state,
                  isSubmitting: false,
                  paramOpen: false,
                  paramDropDowns: false
                })
                props.fetchInitialData.createSnack(
                  'Successfully ran report',
                  'success',
                  3000
                )
              }
            } else {
              if (isMountedRef.current) {
                setState({ ...state, isSubmitting: false, paramOpen: false })
                props.fetchInitialData.createSnack(
                  JSON.stringify(resp),
                  'warning',
                  5000
                )
              }
            }
      // const resp = await LambdaFetch(
      //   'apix-trigger-report',
      //   'post',
      //   props.fetchInitialData.credentials.user.accessToken,
      //   JSON.stringify({
      //     ...fetchData
      //   }),
      //   '',
      //   props.fetchInitialData.credentials,
      //   true
      // )

      // if (resp.data.body.statusCode === 200) {
      //   setState({
      //     ...state,
      //     isSubmitting: false,
      //     paramOpen: false,
      //     paramDropDowns: false
      //   })
      //   props.fetchInitialData.createSnack(
      //     'Successfully ran report',
      //     'success',
      //     3000
      //   )
      // } else {
      //   setState({ ...state, isSubmitting: false, paramOpen: false })
      //   props.fetchInitialData.createSnack(
      //     JSON.stringify(resp),
      //     'warning',
      //     5000
      //   )
      // }
    } catch (e) {
      console.log(e)
    }
  }

  const onTagsChange = (event, values, name) => {
    setReportParams({ ...reportParams, [name]: values })
  }
  const getMuiTheme = () => {
    createMuiTheme({
      overrides: {
        MuiTableCell: {
          root: {
            backgroundColor: '#FFF'
          }
        }
      }
    })
  }

  const { reports, isLoading, currentReport, paramOpen, paramDropDowns } = state

  if (isLoading) {
    return <LoadingCircle />
  }

  const { classes } = props
  let tabs = []
  if (state.reports) {
    tabs = state.reports.forEach(report => {
      if (tabs.indexOf(report.category) === -1) {
        tabs.push(reports.category)
      }
    })
  }

  const rawModules = props?.fetchInitialData?.credentials?.clientModules
  const clientModules = resolveEnabledModules(rawModules)
  return (
    <div>
      {paramOpen && (
        <Dialog
          fullWidth
          scroll={'paper'}
          open={paramOpen}
          // onClose={handleClose} // This allows the user to close the dialog by clicking outside the dialog or clicking escape character
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle>{currentReport.report_name}</DialogTitle>
          <DialogContent dividers>
            <form id='report-form' onSubmit={runReport}>
              <Grid container justifyContent='flex-start' spacing={2}>
                <Grid item xs={12} sm={12} md={12}>
                  <TextField
                    id={'jobName'}
                    required={true}
                    label={'Job Name'}
                    variant='filled'
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position='start'>
                          <span />
                        </InputAdornment>
                      ),
                      inputProps: {
                        maxLength: 50
                      }
                    }}
                  />
                </Grid>

                {/* {JSON.parse(currentReport.parameters).map((p, index) => { */}
                {currentReport.parameters.map((p, index) => {
                  if (p.fieldType === 'dynamicList') {
                    return (
                      <Grid key={index} item xs={12} sm={12} md={12}>
                        <LazyLoadingAutocomplete
                          onChange={val => onTagsChange(null, val, p.name)}
                          id={p.displayName}
                          name={p.displayName}
                          required={p.isRequired}
                          variant='filled'
                          label={p.displayName}
                          options={
                            state.dropdownData[p.name]
                              ? state.dropdownData[p.name]
                              : []
                          }
                          renderInput={params => (
                            <TextField
                              required
                              {...params}
                              label={p.displayName}
                              variant='filled'
                            />
                          )}
                        />
                      </Grid>
                    )
                  } else if (p.fieldType === 'smart-autocomplete') {
                    const isDisabled = p.dependsOn
                      ? p.dependsOn.split(',').reduce((acc, cur) => {
                          if (!reportParams[cur]) {
                            acc = true
                          }
                          return acc
                        }, false)
                      : false

                    const storedProc = p.procedureParams
                      .split(',')
                      .reduce((acc, param, index) => {
                        return (acc +=
                          index + 1 === p.procedureParams.split(',').length
                            ? `?)`
                            : `?,`)
                      }, `call ${p.procedure}(?,?,`)

                    const reportingParams = p.procedureParams
                      .split(',')
                      .reduce((acc, cur) => {
                        return [
                          ...acc,
                          reportParams[cur] ? reportParams[cur] : -1
                        ]
                      }, [])

                    if (p.multiSelect) {
                      return (
                        <SeverSideMultiAutoComplete
                          required={p.isRequired === 'True' || p.isRequired}
                          id={p.name}
                          label={p.displayName}
                          disabled={isDisabled}
                          dontAutoHighlight
                          dontOpenOnFocus
                          fullWidth
                          margin={'standard'}
                          padding={'8px'}
                          accessToken={
                            props.fetchInitialData.credentials.user.accessToken
                          }
                          error={`No ${p.displayName} Found`}
                          variant='filled'
                          handleChange={(id, hit) => {
                            setReportParams({ ...reportParams, [p.name]: id })
                          }}
                          credentials={props.fetchInitialData.credentials}
                          apiResource='reports'
                          secondaryParams={{
                            lookupCol: p.name,
                            params: reportingParams,
                            storedProc: storedProc,
                            action: 'run-reports-autocomplete'
                          }}
                        />
                      )
                    } else {
                      return (
                        <ServerSideAutoCompletev2
                          required={p.isRequired === 'True' || p.isRequired}
                          id={p.name}
                          label={p.displayName}
                          disabled={isDisabled}
                          dontAutoHighlight
                          dontOpenOnFocus
                          fullWidth
                          margin={'standard'}
                          padding={'8px'}
                          accessToken={
                            props.fetchInitialData.credentials.user.accessToken
                          }
                          error={`No ${p.displayName} Found`}
                          variant='filled'
                          handleChange={(id, hit) => {
                            setReportParams({ ...reportParams, [p.name]: id })
                          }}
                          credentials={props.fetchInitialData.credentials}
                          apiResource='reports'
                          secondaryParams={{
                            lookupCol: p.name,
                            params: reportingParams,
                            storedProc: storedProc,
                            action: 'run-reports-autocomplete'
                          }}
                        />
                      )
                    }
                  } else if (p.fieldType === 'autocomplete') {
                    return (
                      <ServerSideAutoCompletev2
                        required={p.isRequired === 'True' || p.isRequired}
                        id={p.name}
                        label={p.displayName}
                        dontAutoHighlight
                        dontOpenOnFocus
                        fullWidth
                        margin={'standard'}
                        padding={'8px'}
                        accessToken={
                          props.fetchInitialData.credentials.user.accessToken
                        }
                        error={`No ${p.displayName} Found`}
                        variant='filled'
                        handleChange={(id, hit) => {
                          setReportParams({ ...reportParams, [p.name]: id })
                        }}
                        credentials={props.fetchInitialData.credentials}
                        apiResource='reports'
                        secondaryParams={{
                          category: p.category,
                          table: p.table,
                          action: 'autocomplete-select'
                        }}
                      />
                    )
                  } else if (p.fieldType === 'autocomplete-serverside') {
                    return (
                      <ServerSideAutoCompletev2
                        required={p.isRequired === 'True' || p.isRequired}
                        id={p.name}
                        label={p.displayName}
                        dontAutoHighlight
                        dontOpenOnFocus
                        fullWidth
                        margin={'standard'}
                        padding={'8px'}
                        accessToken={
                          props.fetchInitialData.credentials.user.accessToken
                        }
                        error={`No ${p.displayName} Found`}
                        variant='filled'
                        handleChange={(id, hit) => {
                          onTagsChange(null, id, p.name)
                        }}
                        credentials={props.fetchInitialData.credentials}
                        apiResource='autocomplete'
                        secondaryParams={{
                          category: p.autoCategory,
                          dropdown: p.dropdown,
                          action: 'autocomplete-reports-select'
                        }}
                      />
                    )
                  } else if (p.fieldType && p.fieldType.toLowerCase() === 'opensearch') {
                    // Build filters from filterMapping and current reportParams
                    const filters = p.filterMapping
                      ? Object.keys(p.filterMapping).reduce((acc, filterKey) => {
                          const paramName = p.filterMapping[filterKey]
                          const paramValue = reportParams[paramName]
                          if (paramValue) {
                            acc[filterKey] = paramValue
                          }
                          return acc
                        }, {})
                      : {}

                    // Determine if field should be disabled based on dependencies
                    const isDisabled = p.dependsOn
                      ? p.dependsOn.split(',').reduce((acc, cur) => {
                          const trimmedParam = cur.trim()
                          if (trimmedParam && !reportParams[trimmedParam]) {
                            acc = true
                          }
                          return acc
                        }, false)
                      : false

                    return (
                      <Grid key={index} item xs={12} sm={12} md={12}>
                        <OpenSearchDropdown
                          id={p.name}
                          required={p.isRequired === 'True' || p.isRequired}
                          disabled={isDisabled}
                          label={p.displayName}
                          variant='filled'
                          page={p.page}
                          entity={p.entity}
                          searchFields={p.searchFields || ['DISPLAY']}
                          displayField={p.displayField || 'DISPLAY'}
                          valueField={p.valueField || 'VALUE'}
                          accessToken={
                            props.fetchInitialData.credentials.user.accessToken
                          }
                          credentials={props.fetchInitialData.credentials}
                          filters={filters}
                          onChange={(val) => {
                            const value = val?.[p.valueField || 'VALUE'] || null
                            setReportParams({ ...reportParams, [p.name]: value })
                          }}
                        />
                      </Grid>
                    )
                  } else if (p.fieldType === 'finiteList') {
                    return (
                      <Grid key={index} item xs={12} sm={12} md={12}>
                        <Autocomplete
                          required
                          getOptionLabel={option => option}
                          id={p.name}
                          options={p.list ? p.list.split(',') : []}
                          renderInput={params => (
                            <TextField
                              required
                              {...params}
                              label={p.displayName}
                              variant='filled'
                            />
                          )}
                        />
                      </Grid>
                    )
                  } else if (p.fieldType === 'autocomplete-all') {
                    return (
                      <Grid key={index} item xs={12} sm={12} md={12}>
                        <LazyLoadingAutocomplete
                          {...props}
                          onChange={val => {
                            setReportParams({
                              ...reportParams,
                              [p.name]: val?.key_value
                            })
                          }}
                          id={p.name}
                          name={p.name}
                          required={p.isRequired}
                          variant='filled'
                          label={p.displayName}
                          autoCategory={p.autoCategory}
                          dropdown={p.dropdown}
                          renderInput={params => (
                            <TextField
                              required
                              {...params}
                              label={p.displayName}
                              variant='filled'
                            />
                          )}
                        />
                      </Grid>
                    )
                  } else {
                    // Check if this is a date field and use DateInput component
                    if (p.fieldType === 'date') {
                      return (
                        <Grid key={index} item xs={12} sm={12} md={12}>
                          <DateInput
                            id={p.name}
                            label={p.displayName}
                            value={reportParams[p.name] || ''}
                            onChange={(e) => {
                              setReportParams({ ...reportParams, [p.name]: e.target.value });
                            }}
                            required={p.isRequired === 'True' || p.isRequired}
                            variant='filled'
                            fullWidth
                          />
                        </Grid>
                      );
                    } else {
                      // Original TextField for non-date fields
                      return (
                        <Grid key={index} item xs={12} sm={12} md={12}>
                          <TextField
                            id={p.name}
                            type={p.fieldType}
                            required={p.isRequired === 'True' || p.isRequired}
                            label={p.displayName}
                            variant='filled'
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position='start'>
                                  <span />
                                </InputAdornment>
                              )
                            }}
                          />
                        </Grid>
                      );
                    }
                  }
                })}
              </Grid>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Close</Button>

            <LoadingButton
              form='report-form'
              label='Confirm'
              isLoading={state.isSubmitting}
              color='primaryVLButton'
              buttonType='submit'
            />
          </DialogActions>
        </Dialog>
      )}
      <div className='paymentForm'>
        <Paper style={{ margin: 'auto', maxWidth: '900px' }}>
          <div className={classes.root}>
            <AntTabsVert
              color={props.fetchInitialData.credentials.primaryAppColor}
              orientation='vertical'
              variant='scrollable'
              value={state.tabValue}
              onChange={(event, newValue) =>
                setState({ ...state, tabValue: newValue })
              }
              aria-label='Vertical tabs example'
              style={{ width: '120px' }}
            >
              {(() => {
              // Filter tabs by enabled modules
              const filteredTabs = state.tabs.filter(t => {
                // Report categories are keyed by module name (e.g., 'HR', 'AP', 'ACTIVITY')
                // Check if the category's module is enabled for this client
                return isModuleEnabled(t, clientModules)
              })
              
              return filteredTabs.map((tab, index) => {
                return (
                  <AntTab
                    color={props.fetchInitialData.credentials.primaryAppColor}
                    key={index}
                    label={tab}
                    value={index}
                  />
                )
              })
            })()}
            </AntTabsVert>
            {(() => {
              // Filter tabs by enabled modules (same filter as above)
              const filteredTabs = state.tabs.filter(t => {
                return isModuleEnabled(t, clientModules)
              })
              
              return filteredTabs.map((tab, index) => {
                return (
                  <TabPanel
                    key={index}
                    style={{
                      paddingTop: 0,
                      paddingLeft: 0,
                      paddingRight: '0.5rem',
                      width: '100%'
                    }}
                    value={state.tabValue}
                    index={index}
                  >
                    <List
                      style={{ width: '100%' }}
                      dense
                      aria-label='main mailbox folders'
                    >
                      {reports
                        .filter(report => report.category === tab)
                        .sort((a, b) => a.report_name.localeCompare(b.report_name))
                        .map((row, index) => {
                          return (
                            <ListItem
                              button
                              style={{ minWidth: '100%' }}
                              onClick={() => handleCurrentReport(row)}
                              key={index}
                            >
                              <ListItemText
                                primary={row.report_name}
                                secondary={row.description}
                              />
                            </ListItem>
                          )
                        })}
                    </List>
                  </TabPanel>
                )
              })
            })()}
          </div>
          <a style={{float: 'right', opacity: '10%', fontSize: '11px'}}>powered by Athena</a>
        </Paper>
      </div>
    </div>
  )
}

export default withStyles(styles)(withSnackbar(AthenaReports))

function TabPanel (props) {
  const { children, value, index, ...other } = props
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box style={{ paddingLeft: '1rem' }}>{children}</Box>}
    </div>
  )
}

function replaceParams (text, namedParams) {
  for (const paramName in namedParams) {
    if (namedParams.hasOwnProperty(paramName)) {
      const paramValue = namedParams[paramName]
      text = text.split(paramName).join(paramValue)
    }
  }
  return text
}
